export const CATEGORIES = [
  { id: "think", label: "Tư Duy", emoji: "🧠", color: "#7C3AED" },
  { id: "read", label: "Đọc & Học", emoji: "📚", color: "#0EA5E9" },
  { id: "body", label: "Thể Chất", emoji: "⚡", color: "#10B981" },
  { id: "social", label: "Kết Nối", emoji: "🌱", color: "#F59E0B" },
  { id: "focus", label: "Tập Trung", emoji: "🎯", color: "#EF4444" },
  { id: "create", label: "Sáng Tạo", emoji: "✨", color: "#EC4899" },
];

export const today = new Date();
const pad = n => String(n).padStart(2, "0");
export const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
export const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 86400000);
